<template>
  <div style="display: flex; justify-content: center; align-items: center;">
    <span class="switch" :class="{active}" @click="toggle"></span>
  </div>
</template>

<script>
export default {
  name: 'ToggleSwitch',
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    toggle() {
      this.$emit('toggle');
    },
  },
};
</script>

<style lang="scss">
.switch {
  content: "";
  background: #eaeaea;
  height: 1em;
  width: 1.8em;
  border-radius: 2em;
  display: block;
  box-shadow: inset 0 0 5px 0 rgba(0,0,0,0.1);
  transition: all .2s ease;
}

.switch:after {
  content: "";
  margin: 0.15em;
  border-radius: 50%;
  height: 0.7em;
  width: 0.7em;
  background: #777777;
  display: block;
  box-shadow: 0 0 5px 0 rgba(0,0,0,0.1);
  transition: all .2s ease;
}

.switch.active {
  background: #76a0d7;
}

.switch.active:after {
  margin-left: 0.9em;
  background: #eff0f1;
}
</style>
